var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowToTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "33px",
    viewBox: "0 0 28 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-to-top") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buscaride-website",
    transform: "translate(-1128.000000, -6763.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(1108.407141, 6745.717198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-to-top",
    transform: "translate(19.945760, 18.196132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.49556323,17.4267641 L12.8996015,6.99460679 C13.23,6.66420828 13.7642614,6.66420828 14.0946599,6.99460679 L24.4986982,17.4267641 C24.8290967,17.7571626 24.8290967,18.291424 24.4986982,18.6218225 L23.1208661,19.9996546 C22.7834378,20.3370829 22.2421466,20.3300531 21.9187779,19.9855951 L15.3248671,13.1597024 L15.3248671,30.6497343 C15.3248671,31.1136981 14.9452603,31.4933049 14.4812965,31.4933049 L12.5129649,31.4933049 C12.049001,31.4933049 11.6693942,31.1136981 11.6693942,30.6497343 L11.6693942,13.1597024 L5.08251328,19.9855951 C4.75211476,20.3230234 4.21082359,20.3300531 3.88042507,19.9996546 L2.50259298,18.6218225 C2.16516472,18.291424 2.16516472,17.7571626 2.49556323,17.4267641 Z M0.843570668,3.6554729 L26.1506907,3.6554729 C26.6146546,3.6554729 26.9942614,3.2758661 26.9942614,2.81190223 L26.9942614,0.843570668 C26.9942614,0.379606801 26.6146546,0 26.1506907,0 L0.843570668,0 C0.379606801,0 0,0.379606801 0,0.843570668 L0,2.81190223 C0,3.2758661 0.379606801,3.6554729 0.843570668,3.6554729 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowToTop);
export default __webpack_public_path__ + "static/media/arrow-to-top.2b4eab1dad02266ce2ada6f1ce61f689.svg";
export { ForwardRef as ReactComponent };